var _style, _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _path6, _polygon, _polygon2, _rect, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKitchenDeco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 50",
    style: {
      enableBackground: "new 0 0 300 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E5E5E5;}\n\t.st1{fill:none;stroke:#E5E5E5;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.5,41h-240c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h240c0.3,0,0.5,0.2,0.5,0.5l0,0 C271,40.8,270.8,41,270.5,41z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.5,40.5c0,0-10.1-13.8-14.5-18.5c-4-4.3-8.5-0.5-9,0L60.5,40.5H104.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.6,22.7c0,0-2.1-4.2-0.1-6.2s6-3,13,1s12,15,12,15s2,5,1,8h-12L90.6,22.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.2,40.5l15.3-13c0,0,3-3,5,0s0,5,0,5l-9.5,8H64.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.5,40.5l5-4c0,0,2-2,4-1s2,4,2,4s0.2,1-1.4,1C90.5,40.5,82.5,40.5,82.5,40.5z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8318 -0.5551 0.5551 0.8318 6.3986 60.2342)",
    className: "st1",
    cx: 102.6,
    cy: 19.6,
    rx: 0.8,
    ry: 1.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7684 -0.64 0.64 0.7684 7.6873 74.3612)",
    className: "st1",
    cx: 106.6,
    cy: 26.6,
    rx: 0.8,
    ry: 1.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6312 -0.7756 0.7756 0.6312 16.263 99.3242)",
    className: "st1",
    cx: 112.6,
    cy: 32.6,
    rx: 0.8,
    ry: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.1,25l39.4-22.5l48.3,38h-82.3C116.5,40.5,118.7,34.5,111.1,25z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "152.4,4 154.5,2.5 198.5,36 198.5,40 198.1,40 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "148,3.9 146.5,2.5 110.1,23.6 111.5,24.5 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 198.5,
    y: 33.5,
    className: "st1",
    width: 54,
    height: 7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.5,9.5c0,0-4-2-3,12s8.7,10,10.3,12h3.7c0,0-3,0-3-3S206.5,11.5,201.5,9.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.4,10.1c0,0,4.6-2,3.4,11.7s-9.9,9.8-11.8,11.7h-4.2c0,0,3.4,0,3.4-2.9S237.7,12,243.4,10.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.5,12.5c0,0-2,14-5,14s-4.4,7-4.4,7h-2.5c0,0,2.9-4,1.9-7s-2-3,3-15c0,0,1-1,1,0s-3,10-3,10s0,1,1,1l4-11 c0,0,1-1,1,0s-3,11-3,11s0,2,1,0s3-9,3-9S258.5,9.5,258.5,12.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.3,11.8c0,0,1.7,14,4.7,14.1c3,0.1,4.2,7.1,4.2,7.1l2.5,0.1c0,0-2.8-4.1-1.7-7s2.1-2.9-2.6-15.1 c0,0-1-1-1,0s2.8,10.1,2.8,10.1s0,1-1,1l-3.7-11.1c0,0-1-1-1,0s2.7,11.1,2.7,11.1s0,2-1,0c-1-2-2.8-9.1-2.8-9.1 S206.4,8.8,206.3,11.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenDeco);
export default __webpack_public_path__ + "static/media/kitchenDeco.51bf05ac2d68c9e0062a61addce071c7.svg";
export { ForwardRef as ReactComponent };